<template>
  <div class="service">
    <div id="map"></div>
    <div class="search">
      <h2>专卖店查询</h2>
      <el-cascader v-model="area" :props="props" size="mimi"></el-cascader>
      <ul class="company-list">
        <li class="item" v-for="item in companyList" :key="item.id" @click="selectCompany(item)">
          <div class="title">{{ item.name }}</div>
          <div class="address">
            <i class="el-icon-location-information"></i>
            {{ item.address }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getArea, getCompanyList } from '@/api/index'
import { loadTMAP } from '@/utils'

export default {
  name: 'Service',
  data() {
    return {
      area: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          let pid = 0
          if (level !== 0) {
            pid = node.value
          }
          level !== 2 &&
            getArea({ pid })
              .then((res) => {
                const nodes = res.data.map((item) => ({
                  value: item.id,
                  label: item.name,
                  leaf: level === 1 || item.children_count === 0
                }))
                resolve(nodes)
              })
              .catch((err) => {
                this.$message.error('加载数据失败')
              })
        }
      },
      companyList: [],
      map: null,
      markers: null
    }
  },
  watch: {
    area(nVal) {
      getCompanyList({ area: nVal })
        .then((res) => {
          this.companyList = res.data
          this.markers.setGeometries([])
          let arr = []
          res.data.forEach((item) => {
            const { id, lng, lat } = item
            arr.push({
              id,
              position: new TMap.LatLng(lat, lng)
            })
          })
          this.markers.setGeometries(arr)
          arr.length && this.map.setCenter(arr[0].position)
        })
        .catch((err) => {
          this.$message.error('加载数据失败')
        })
    }
  },
  mounted() {
    this.initTmap()
  },
  beforeDestroy() {
    this.map && this.map.destroy()
  },
  methods: {
    async initTmap(e) {
      const TMap = await loadTMAP()
      // 设置中心点坐标
      var center = new TMap.LatLng(39.984104, 116.307503)

      this.map = new TMap.Map('map', {
        center: center,
        zoom: 10,
        pitch: 0, // 俯仰度
        rotation: 0 // 旋转角度
      })

      this.markers = new TMap.MultiMarker({
        map: this.map,
        geometries: []
      })

      const ipLocation = new TMap.service.IPLocation()
      ipLocation
        .locate({})
        .then((ret) => {
          const { result } = ret
          const { location, ad_info } = result
          this.map.setCenter(location)
          getCompanyList({ city: ad_info.city }).then((res) => {
            this.companyList = res.data
            let arr = []
            res.data.forEach((item) => {
              const { id, lng, lat } = item
              arr.push({
                id,
                position: new TMap.LatLng(lat, lng)
              })
            })
            this.markers.add(arr)
          })
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    selectCompany({ lat, lng }) {
      this.map.setCenter(new TMap.LatLng(lat, lng))
      this.map.setZoom(17)
    }
  }
}
</script>

<style lang="scss" scoped>
.service {
  min-height: calc(100vh - 100px);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.search {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 1001;
  width: 530px;
  height: calc(100vh - 160px);
  overflow: hidden;
  padding: 24px 24px 0 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
  background-color: $--color-primary;
  opacity: 0.7;
  color: #fff;
  h2 {
    margin: 0 0 16px 0;
  }
  ul {
    list-style: none;
    padding: 0 0 20px 0;
    margin: 20px 0;
    height: 90%;
    overflow: auto;
    li {
      user-select: none;
      cursor: pointer;
    }
    .item {
      padding-bottom: 10px;
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}
#map {
  width: 100%;
  height: calc(100vh - 100px);
}
@media screen and (max-width: 768px) {
  .search {
    width: 50%;
  }
}
</style>
